import CityPageTemplate from "../city-template/CityPageTemplate";
import { flintConfig } from "./data";

export default function FlintPage() {
  return <CityPageTemplate config={flintConfig} />;
}